<div class="d-flex flex-column fixed-size p-4">
    <mat-dialog-content class="flex-fill mat-dialog-content-height">
        <div class="container">
            <div class="row">
                <div class="col-12 text-center mt-2 popup-div-content">
                    <span>Un de mes enfants a déjà été inscrit à Sport dans la ville</span>
                    <span> ou </span>
                    <span>J'ai déjà été inscrit à Sport dans la ville</span>
                    <br/>
                    <span> <a (click)="goToConnexion()" [routerLink]="['/login']"
                              class="linkLog font-weight-bold"> Je me connecte</a>  </span>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <br/>
    <mat-dialog-actions class="m-0 d-flex flex-row justify-content-center">
        <button (click)="onOkClick()" class="mx-3 col-9 btn btn-secondary">Je souhaite réaliser mon inscription ou celle
            de
            mon enfant
        </button>
    </mat-dialog-actions>
</div>
